import React from 'react';
import Tooltip from "../../general/Tooltip";
import './styles.css';

const ICON_SIZE = 18;

/**
 * Icon button for the dark chat header. Icons inherit `currentColor`, so the
 * danger variant can recolour the glyph on hover from CSS alone.
 * Omit `onClick` when the button is used as a Popup trigger — the Popup
 * wrapper handles the click itself.
 */
const HeaderIconButton = React.forwardRef(({
                                               icon,
                                               onClick,
                                               tooltip,
                                               hotkey = '',
                                               danger = false,
                                               active = false,
                                               className = ''
                                           }, ref) => {

    const classes = [
        'header-icon-button',
        danger ? 'header-icon-button--danger' : '',
        active ? 'header-icon-button--active' : '',
        className
    ].filter(Boolean).join(' ');

    const button = (
        <button ref={ref} type="button" className={classes} onClick={onClick}>
            {React.isValidElement(icon)
                ? React.cloneElement(icon, {width: ICON_SIZE, height: ICON_SIZE, stroke: 'currentColor'})
                : icon}
        </button>
    );

    if (!tooltip) return button;

    return (
        <Tooltip text={tooltip} shortcut={hotkey} deltaY={-4}>
            {button}
        </Tooltip>
    );
});

export default HeaderIconButton;



// WEBPACK FOOTER //
// ./src/components-new/buttons/HeaderIconButton/index.jsx